import React from "react";
import Breadcrumb from "../components/Breadcrumb";
import Footer from "../components/Footer";
import Scrolltop from "../components/Scrolltop";
import Header from "../components/Header";

import Bg from "../img/services/golpista_amoroso.jpg"
import GolpistaAmoroso from "../components/GolpistaAmoroso";

import BtWhatsapp from "../components/ButtonWhatsapp3";

const PessoasBreadcrumb = () => {
  return (
    <>
      <Header />
      <main>
        <Breadcrumb
          menu="Serviços"
          name="Golpista Amoroso" 
          bg={Bg}
        />
        <GolpistaAmoroso />
        <Footer />
      </main>
      <BtWhatsapp />
      <Scrolltop />
    </>
  );
};

export default PessoasBreadcrumb;
